import React from 'react';
import { observer } from 'mobx-react';
import PlusRouter from '@fle-ui/plus-router';
import routerConfig from './index.config';

export const ROUTER_BASE = `/site`;

const Router = () => {
  return <PlusRouter routes={routerConfig} basename={ROUTER_BASE} />;
};

export default observer(Router);
